import { DeprecationsPlugin, PromisesPlugin, TemplateParamsPlugin, AliasSortingPlugin } from "/data/runners/gh1202/_work/apps-monorepo/apps-monorepo/node_modules/.pnpm/@unhead+vue@2.1.17_vue@3.5.43_typescript@5.9.2_/node_modules/@unhead/vue/dist/plugins.mjs";
export default {
  disableDefaults: true,
  disableCapoSorting: false,
  plugins: [DeprecationsPlugin, PromisesPlugin, TemplateParamsPlugin, AliasSortingPlugin],
}